module.exports = __webpack_public_path__ + "img/user.4cef3b3e.jpeg";